import { Component, OnInit, Input } from '@angular/core';

import { UsefulLink } from '../../../models/useful-link';
import {GoogleTagManagerService} from '../../../services/google-tag-manager.service';

@Component({
  selector: 'app-useful-link-item',
  templateUrl: './useful-link-item.component.html',
  styleUrls: ['./useful-link-item.component.scss']
})
export class UsefulLinkItemComponent implements OnInit {

  @Input() usefulLink: UsefulLink;

  constructor(private gtmService: GoogleTagManagerService) {
  }

  ngOnInit() {
  }

  openLink() {
    this.gtmService.pushEvent(`Open link - ${this.usefulLink.displayName}`);
    if (this.usefulLink.link) {
      const prefix = 'https://'
      const url: string = this.usefulLink.link.startsWith(prefix) ? this.usefulLink.link: `${prefix}${this.usefulLink.link}`
      window.open(url, '_blank');
    }
  }

}
